import React from 'react';
import OperationButtonsView from '../view/OperationButtonsView';

const row = [
  { id: 'openBrackets', label: '(' },
  { id: 'closeBrackets', label: ')' },
  { id: 'add', label: '+' },
  { id: 'subtract', label: '-' },
  { id: 'multiply', label: '×' },
  { id: 'divide', label: '÷' }
];

const OperationButtonsEngine = ({
  disabledButtons,
  onClickButton = () => {}
}) => {
  row.forEach(oneButton => {
    if (disabledButtons.includes(oneButton.id)) {
      oneButton.disabled = true;
    } else {
      delete oneButton.disabled;
    }
  });
  const viewProps = {
    row,
    onClickButton
  };

  return <OperationButtonsView {...viewProps} />;
};

export default OperationButtonsEngine;
